import { Typography } from '@frontend/design_system'
import { FilterButtonProps } from './types'
import { joinClasses } from 'utils/joinClasses'
import { forwardRef } from 'react'
import styles from './styles.module.scss'

export const FilterButton = forwardRef<HTMLDivElement, FilterButtonProps>(
  (
    {
      label,
      selectedCount,
      isActive,
      onClick,
      iconLeft,
      iconRight,
      disabled,
      onRightIconClick,
      onLeftIconClick,
    },
    ref
  ) => (
    <Typography
      className={joinClasses(
        styles['filter-button'],
        [styles.active, isActive],
        [styles.disabled, disabled],
        [styles.applied, !!selectedCount]
      )}
      Tag="div"
      color="grey650"
      name="body1WMedium"
      onClick={onClick}
      ref={ref}
    >
      {iconLeft && <div onClick={onLeftIconClick}>{iconLeft}</div>}
      {label}
      {!!selectedCount && (
        <Typography
          color="whiteMaster"
          name="body1WMedium"
          className={styles['selected-count']}
        >
          {selectedCount}
        </Typography>
      )}
      {iconRight && <div onClick={onRightIconClick}>{iconRight}</div>}
    </Typography>
  )
)
